import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProjects } from '@modules/accounting-and-finance/interface/projects/projects.interface.ts';

const initialState: IProjects[] = [];

export const ACCGProjectSlice = createSlice({
  name: 'accgProject',
  initialState,
  reducers: {
    setACCGProjects: (_state, action: PayloadAction<IProjects[]>) => {
      return [...action.payload];
    },
    removeACCGProjects: () => {
      return initialState;
    },
  },
});

export default ACCGProjectSlice.reducer;

export const { setACCGProjects, removeACCGProjects } = ACCGProjectSlice.actions;
